export class Actions {
  static INIT = 1;
  static NAVIGATION = 2;
  static BUY_ATTEMPT = 3;
  static BUY_COMPLETE = 4;
  static CONTENT_PLAY = 5;
  static CONTENT_PLAYING = 6;
  static CONTENT_STOP = 7;
  static USER_CHANGE_PASS = 8;
  static USER_CHANGE_MAIL = 9;
  static USER_CHANGE_TEAM = 10;
  static CONTENT_CREATED = 20;
  static CONTENT_MODIFIED = 21;
  static CONTENT_DELETED = 22;
  static CONTENT_FINISHED = 23;
  static USER_CREATED = 30;
  static USER_MODIFIED = 31;
  static USER_DELETED = 32;
  static USER_GRANTED_ROLE = 33;
  static USER_REVOKED_ROLE = 34;
  static USER_DISABLED = 35;
  static USER_ENABLED = 36;
  static HOME_IMAGES_MODIFIED = 40;
  static TOURNAMENTS_MODIFIED = 41;
  static SUBSCRIPTION_GRANTED = 50;
  static SUBSCRIPTION_REVOKED = 51;
  static PAYMENT_MANUAL = 60;
  static SIGNAL_CREATED = 61;
  static SIGNAL_MODIFIED = 62;
  static SIGNAL_DELETED = 63;
  static REMOTE_BROADCAST_CREATED = 64;
  static REMOTE_BROADCAST_MODIFIED = 65;
  static REMOTE_BROADCAST_DELETED = 66;
  static TEAM_CREATED = 67;
  static TEAM_MODIFIED = 68;
  static TEAM_DELETED = 69;
  static RTMP_RECYCLED = 70;
  static RTMP_REACTIVATED = 72;
  static BRAND_CREATED = 80;
  static BRAND_MODIFIED = 81;
}
